import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IAngularEvent, IAugmentedJQuery, IController, IDeferred, IModule, IOnChangesObject, IScope} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {gettextCatalog} from "angular-gettext";
import {SakRessurs, Sakstidspunkt} from "felles/tjenester/ressurser/SakRessurs";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {FavorittTjeneste} from "felles/tjenester/modulspesifikke/FavorittTjeneste";
import {Filer} from "felles/tjenester/Filer";
import {SakWebRessurs} from "../../../../tjenester/ressurser/SakWebRessurs";
import {Dialog} from "../../../../tjenester/Dialog";
import {RedigerAvstemningDialog} from "../../modale/redigerAvstemningDialog/redigerAvstemningDialog";
import {Debugger} from "debug";
import {BasisKontroller} from "../../../basis/BasisKontroller";
import moment from "moment";
import {VisSkjermingDialog} from "../../modale/visSkjermingDialog/visSkjermingDialog";
import {IStateParamsService} from "angular-ui-router";
import {UIRouterGlobals} from "@uirouter/angularjs";
import {Konfigurasjon} from "../../../../../felles/infrastruktur/Konfigurasjon";
import {MenyTjeneste} from "../../../../komponenter/meny/meny";
import _ from "lodash";
import {kopierFraAjsTilNg2, kopierFraNg2TilAjs} from "felles-ng2/modell/ajsNg2ModellBroer";
import {BeslutningDatatjenesteForAjs, kallNedgradertNg2TjenesteVed, MøteDatatjenesteForAjs, Ng2DialogTjenesterForAjs, OppgaveDatatjenesteForAjs, SakDatatjenesteForAjs, SaksdokumentDatatjenesteForAjs} from "web/nedgraderteNg2Tjenester";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {filter, Subject} from "rxjs";
import {omsluttLeveringIAjsApplyAsync, takeUntilAjs$destroy} from "felles/ng2/rxjsHjelpere";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {SakstidspunkterBeregning} from "felles-ng2/tjenester/Sakstidspunkter";
import {erIkkeTomListe} from "felles-ng2/støttefunksjoner/lister";
import {Leveringsvalg} from "felles-ng2/tjenester/datalager/datatjeneste";
import {AgendaelementModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";
import {beslutningsforslag, endeligeBeslutninger} from "felles-ng2/modell/beslutningModellHjelpere";
import {GoogleDriveFilvelgerGui} from "web-ng2/delt/komponenter/filvelger-skytjenester/modale/googledrive-filvelger-dialog/GoogleDriveFilvelgerGui";
import {scrollTilSenter} from "web-ng2/delt/dom/scrollIntoView";
import {BeslutningListevisningKompaktKomponent} from "web-ng2/moduler/beslutning/komponenter/beslutning-listevisning-kompakt/beslutning-listevisning-kompakt";
import {OppgaveListevisningKompaktKomponent} from "web-ng2/moduler/oppgave/komponenter/oppgave-listevisning-kompakt/oppgave-listevisning-kompakt";
import {RegistrerDokumentArkfane} from "web-ng2/moduler/sak/modale/registrer-saksdokument-dialog/registrer-saksdokument-dialog";

const debug: Debugger = require('debug')('SakKontroller');
const css = require('./sak.scss');

export class SakKontroller implements IController {

    static eventSaksredigeringVarighetEndret = 'SakKontroller.eventSaksredigeringVarighetEndret';

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmMoeteSak', {
              bindings: {
                  sak: '<',
                  sakstidspunkter: '<'
              },
              controller: SakKontroller.forInjisering(),
              template: require('./sak.html')
          })
    }

    static forInjisering() {
        return [
            regNavn.ng.$element,
            regNavn.ng.$scope,
            regNavn.ng.ui.$stateParams,
            regNavn.ng.ui.$uiRouterGlobals,
            regNavn.md.$mdDialog,
            Kontekst.regNavn,
            Konfigurasjon.regNavn,
            FavorittTjeneste.regNavn,
            MenyTjeneste.regNavn,
            SakRessurs.regNavn,
            SakWebRessurs.regNavn,
            Filer.regNavn,
            RedigerAvstemningDialog.regNavn,
            WebNavigasjon.regNavn,
            Dialog.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            ng2RegNavn.SakDatatjenesteForAjs,
            ng2RegNavn.SaksdokumentDatatjenesteForAjs,
            ng2RegNavn.MøteDatatjenesteForAjs,
            ng2RegNavn.OppgaveDatatjenesteForAjs,
            ng2RegNavn.BeslutningDatatjenesteForAjs,
            ng2RegNavn.Ng2DialogTjenesterForAjs,
            SakKontroller
        ]
    }

    constructor(private $element: IAugmentedJQuery,
                private $scope: IScope,
                private $stateParams: IStateParamsService,
                private $uiRouterGlobals: UIRouterGlobals,
                private $mdDialog: angular.material.IDialogService,
                private kontekst: Kontekst,
                private konfigurasjon: Konfigurasjon,
                private favorittTjeneste: FavorittTjeneste,
                private menyTjeneste: MenyTjeneste,
                private sakRes: SakRessurs,
                private sakWebRes: SakWebRessurs,
                private filer: Filer,
                private avstemningDialog: RedigerAvstemningDialog,
                private webNavigasjon: WebNavigasjon,
                private dialog: Dialog,
                private meldingTilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog,
                private sakDatatjenesteForAjs: SakDatatjenesteForAjs,
                private saksdokumentDatatjenesteForAjs: SaksdokumentDatatjenesteForAjs,
                private møteDatatjenesteForAjs: MøteDatatjenesteForAjs,
                private oppgaveDatatjenesteForAjs: OppgaveDatatjenesteForAjs,
                private beslutningDatatjenesteForAjs: BeslutningDatatjenesteForAjs,
                private ng2DialogTjenesterForAjs: Ng2DialogTjenesterForAjs
    ) {
        //saksrekkefølge oppdatert håndteres via MøteKontroller
        this.registrerDraOgSlippDokumentHåndtering();

        if (this.$stateParams.redigerSak === true) this.redigerSak();

        //last sak når this.sakEndret publiserer (via $onChanges(..))
        //så lenge vi er i en blandet verden med ajs og ng2 vil noe unødvendig lasting forekomme, feks
        //når sak redigeres vil oppdatert sak skrives til datalager, som så lever til SakKontroller via $onChanges
        //som igjen fører til at this.sakEndret leverer som i sin tur fører til at sak lastes fra server
        //vanskelig å filtrere bort da i ikke enkelt kan skille mellom at bruker nav til sak (da skal vi last fra server)
        //og bruker har redigert sak..
        kallNedgradertNg2TjenesteVed(
          this.$scope,
          this.sakEndret,
          this.sakDatatjenesteForAjs.tjeneste(),
          (sak, sakDatatjeneste) => sakDatatjeneste.hent(sak.id, Leveringsvalg.lever_undefined_ved_slettet)
        )
          .subscribe(sak => {
              if (erIkkeNil(sak)) {
                  this.initSak(kopierFraNg2TilAjs(sak));

              } else {
                  this.møteDatatjenesteForAjs.tjeneste().then(møteDatatjeneste => {
                      //ikke naviger dersom møtet har blitt slettet
                      if (!møteDatatjeneste.eksistererILokallager(this.sak.moete.id)) return;

                      //sak har blitt slettet fra lageret
                      this.webNavigasjon.gåTilMøte(this.sak.moete.id);
                  });
              }
          });

        //sett this.harDokumenter vhja saksdokumentDatatjeneste når sak endres
        kallNedgradertNg2TjenesteVed(
          this.$scope,
          this.sakEndret,
          this.saksdokumentDatatjenesteForAjs.tjeneste(),
          (sak, saksdokumentDatatjeneste) => saksdokumentDatatjeneste.finnTilknyttetSakFraLokallager(sak.id)
        ).subscribe(dokumenter => this.harDokumenter = erIkkeTomListe(dokumenter));

        //setter this.harOppgaver
        kallNedgradertNg2TjenesteVed(
          this.$scope,
          this.sakEndret,
          this.oppgaveDatatjenesteForAjs.tjeneste(),
          (sak, oppgaveDatatjeneste) => oppgaveDatatjeneste.finnTilknyttetSakFraLokallager(sak.id)
        ).subscribe(oppgaver => this.harOppgaver = erIkkeTomListe(oppgaver));

        //setter this.harForslagTilBeslutninger / this.harEndeligeBeslutninger
        kallNedgradertNg2TjenesteVed(
          this.$scope,
          this.sakEndret,
          this.beslutningDatatjenesteForAjs.tjeneste(),
          (sak, beslutningDatatjeneste) => beslutningDatatjeneste.finnTilknyttetSakFraLokallager(sak.id)
        ).subscribe(beslutninger => {
            this.harForslagTilBeslutninger = erIkkeTomListe(beslutningsforslag(beslutninger))
            this.harEndeligeBeslutninger = erIkkeTomListe(endeligeBeslutninger(beslutninger))
        });
    }

    sak: l.AgendaelementModell; //settes via bindings/$onChanges
    sakNg2: AgendaelementModell; //settes via bindings/$onChanges
    sakstidspunkter: SakstidspunkterBeregning; //settes via bindings/$onChanges

    sakstidspunkt: Sakstidspunkt; //settes via initSakstidspunkt()
    erRedigerSak = false;
    erRedigerReferat = false;

    tvingVisKommentarer = false;

    fabMenyAktivert = false;
    redigeringMulig = false;
    kopierMulig = false;
    nyOppgaveMulig = false;
    moeteStartdatoPassert = false;

    private harDokumenter = false;
    private harOppgaver = false;
    private harForslagTilBeslutninger = false;
    private harEndeligeBeslutninger = false;
    private sakEndret = new Subject<l.AgendaelementModell>();

    aktiverFabMeny() {
        this.fabMenyAktivert = true;
    }

    deaktiverFabMeny() {
        this.fabMenyAktivert = false;
    }

    /** forhindrer at klikk på åpen speed dial fører til at denne lukkes*/
    vedFabMenyKlikk($event: IAngularEvent) {
        if (this.fabMenyAktivert && this.konfigurasjon.wkMenyHoverTriggerAktivert) {
            $event.preventDefault();
            $event.stopPropagation();
        }
    }

    menyDeaktivert() {
        return this.menyTjeneste.erDeaktivert();
    }

    aapneSakdokument() {
        window.open(this.sakRes.sakdokumentUrl(this.sak), "_blank");
    }

    redigerSak() {
        this.erRedigerSak = true;
    }

    redigerSakFerdig() {
        //denne trigges av ng2-komponent - sørger derfor for at ajs fanger opp endringen
        this.$scope.$applyAsync(() => this.erRedigerSak = false);
    }

    slettSak() {
        this.sakDatatjenesteForAjs.tjeneste()
          .then(sakDatatjeneste => {
              //stuer unna møteId før sak slettes tilfelle vi får et race mellom koden som nullstiller this.sak og kallet til møteDatatjeneste.relast(
              var møteId = this.sak.moete.id;
              //sakDatatjeneste.hent subscription vil håndtere nav til møte (ved sletting leveres undefined til sak-observatør)
              return sakDatatjeneste.slett(this.sak.id)
                .then(() => this.møteDatatjenesteForAjs.tjeneste())
                .then(møteDatatjeneste => {
                    //sakslisten må relastes (bla pga endring i saksnummer)
                    møteDatatjeneste.relast(møteId)
                });
          });
    }

    flyttSak() {
        this.ng2DialogTjenesterForAjs.sakFlyttDialog(kopierFraAjsTilNg2(this.sak));
    }

    kopierSak() {
        this.ng2DialogTjenesterForAjs.sakKopierDialog(kopierFraAjsTilNg2(this.sak));
    }

    nyOppgave() {
        this.ng2DialogTjenesterForAjs.oppgaveOpprettDialogKomponentVisOpprettUnderSak(kopierFraAjsTilNg2(this.sak));
    }

    nyAvstemning() {
        this.avstemningDialog.visNyAvstemningDialog(this.sak);
    }

    nyBeslutning() {
        this.ng2DialogTjenesterForAjs.beslutningOpprettDialogKomponentVis(kopierFraAjsTilNg2(this.sak), !this.moeteStartdatoPassert)
    }

    nyKommentarTraad() {
        //dette kan gjøres ved å injisere ny-kommentar-traad komponenten og kalle fokus metode på denne når sak.ts er migrert til ng2
        setTimeout(() => this.$element.find('ny-kommentar-traad textarea').focus(), 100);
        this.tvingVisKommentarer = true;
    }

    redigerReferat() {
        //denne trigges av ng2-komponent - sørger derfor for at ajs fanger opp endringen
        this.$scope.$applyAsync(() => this.erRedigerReferat = true);
    }

    redigerReferatAvsluttet(lagret: boolean){
        //denne trigges av ng2-komponent - sørger derfor for at ajs fanger opp endringen
        this.$scope.$applyAsync(() => this.erRedigerReferat = false);
    }

    erVisSaksdokumenter() {
        if (!this.sak) return false; //sak ikke lastet enda..
        const opplastinger = this.sakWebRes.finnOpplastinger(this.sak.id);
        return this.harDokumenter || (opplastinger && opplastinger.length > 0);
    }

    visRegistrerDokumentDialog() {
        this.ng2DialogTjenesterForAjs.registrerSaksdokumentDialogKomponent(kopierFraAjsTilNg2(this.sak));
    }

    erFavoritt() {
        return this.favorittTjeneste.erFavoritt(this.sak);
    }

    endreFavorittmarkering() {
        this.favorittTjeneste.endreFavorittmarkeringForSak(this.sak)
    }

    navigerTilTema() {
        this.webNavigasjon.gåTilListeSakerKnyttetTilTema(this.sak);
    }

    navigerTilSakstype() {
        this.webNavigasjon.gåTilListeSakerKnyttetTilSakstype(this.sak);
    }

    redigerSkjerming() {
        VisSkjermingDialog.visSkjermingDialog({
              entitetType: 'sak',
              gruppeId: () => this.sak.eiendeGruppeId,
              hentSkjerming: () => this.sakRes.hentSkjerming(this.sak.id).$promise,
              oppdaterSkjerming: (spesifikasjon: l.OppdaterSkjermingSpesifikasjon) => this.sakRes.oppdaterSkjerming(this.sak.id, spesifikasjon).$promise
          },
          this.$mdDialog)
          .then(() => this.relastMøte()) //nødvendig å oppdatere på møtenivå da melding om skjerming (wmMoeteSkjermetTips) vises basert på møtemodell
          .catch(_.noop);
    }

    $onChanges(endringer: IOnChangesObject) {
        dersomChangesInneholder(endringer, 'sak', sak => {
            this.sakEndret.next(sak); //fører til at ferske data lastes fra server
            this.initSak(sak);
            this.initSakstidspunkt();
        });

        dersomChangesInneholder(endringer, 'sakstidspunkter', sakstidspunkter => this.initSakstidspunkt());
    }

    $onDestroy(): void {
        this.$scope.$root.$broadcast(BasisKontroller.eventer.draOgSlippDokumenterAktiver, false);
    }

    // hjelpemetoder

    private initSak(sak: l.AgendaelementModell) {
        this.tvingVisKommentarer = false;
        this.sak = sak;
        this.sakNg2 = kopierFraAjsTilNg2(sak);
        this.redigeringMulig = this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.sak.eiendeGruppeId) && !this.sak.moete.laastForRedigering;
        this.kopierMulig = this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.sak.eiendeGruppeId);
        //ny oppgave kan opprettes selvom protokoll(møte) er låst
        this.nyOppgaveMulig = this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.sak.eiendeGruppeId);
        this.moeteStartdatoPassert = moment(this.sak.moete.dato.start).isBefore(moment());
        this.$scope.$root.$broadcast(BasisKontroller.eventer.draOgSlippDokumenterAktiver, this.redigeringMulig);
        this.scrollForespurtElementEllerVarselDersomIkkeFinnes();
    }

    private initSakstidspunkt() {
        if (erNil(this.sak) || erNil(this.sakstidspunkter)) return;

        this.sakstidspunkter.tidspunkterSomObserverbar()
          .pipe(
            //dersom sak har blitt slettet eller flyttet KAN det være at vi får levert tidspunkter som ikke inneholder sak fordi takeUntilAjs$destroy ikke har hatt effekt enda
            filter(tidspunkter => tidspunkter.harForSak(this.sak.id)),
            takeUntilAjs$destroy(this.$scope),
            omsluttLeveringIAjsApplyAsync(this.$scope))
          .subscribe(tidspunkter => this.sakstidspunkt = tidspunkter.forSak(this.sak.id).somAjsTidspunkter());
    }

    private relastMøte() {
        this.møteDatatjenesteForAjs.tjeneste().then(møteDatatjeneste =>
          møteDatatjeneste.relast(this.sak.moete.id));
    }

    /** registrerer lytter som blir kalt dersom dokument slippes i nettleservinduet.
     * Se BasisKontroller for initiell håndtering av dra-og-slipp eventer. */
    private registrerDraOgSlippDokumentHåndtering() {
        this.$scope.$on(BasisKontroller.eventer.draOgSlippDokumenterSluppet, (event: IAngularEvent, filer: File[]) => {
            this.registrerSaksdokument(filer);
        });
        this.$scope.$on(BasisKontroller.eventer.draOgSlippDokumenterTilValidering, (event: IAngularEvent, fil: File, defered: IDeferred<boolean | string>) => {
            if (fil && fil.name && this.erGoogleDocsFiltype(fil.name)) {
                this.dialog.confirm(this.gettextCatalog.getString('Opplasting av dokumenter fra Google'),
                  '<p>' + this.gettextCatalog.getString('Du har prøvd å dra-og-slippe et Google-docs dokument inn i saken.') + '</p>' +
                  '<p>' + this.gettextCatalog.getString('Google-docs dokumenter kan legges til saken ved å velge FILVELGER og deretter "Google Drive"') + '</p>',
                  this.gettextCatalog.getString('Åpne filvelger'),
                  this.gettextCatalog.getString('Avbryt'))
                  .then(() => this.ng2DialogTjenesterForAjs.registrerSaksdokumentDialogKomponent(kopierFraAjsTilNg2(this.sak), RegistrerDokumentArkfane.skytjenester))
                  .catch(_.noop);
                return defered.resolve(false)
            }
            defered.resolve(true);
        });
    }

    private registrerSaksdokument(filer: File[]) {
        if (!filer) return;
        this.sakWebRes.registrerDokumenter(
          this.sak.id,
          filer,
          nyttDokument => {
          });
    }

    /** scroller til forespurt entitet eller viser melding til bruker dersom forespurt oppgaveId/dokumentId/beslutningId/avstemningId ikke ble funnet */
    private scrollForespurtElementEllerVarselDersomIkkeFinnes() {
        let forespurtOppgave = this.$uiRouterGlobals.params.oppgaveId;
        if (forespurtOppgave) {
            if (![...this.sak.oppgaver, ...this.sak.beslutninger.flatMap(beslutning => beslutning.oppgaver)]
              .map(oppgave => oppgave.id)
              .includes(forespurtOppgave))
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Forespurt oppgave eksisterer ikke'));
            else
                scrollTilSenter(OppgaveListevisningKompaktKomponent.scrollTilElementCssUttrykk(forespurtOppgave), 100);
        }

        let forespurtDokument = this.$uiRouterGlobals.params.dokumentId;
        if (forespurtDokument) {
            if (!this.sak.dokumenter.some(d => d.dokumentId === forespurtDokument))
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Forespurt dokument eksisterer ikke'));
            else
                scrollTilSenter(`#dok-${forespurtDokument}`, 100);
        }

        let forespurtBeslutning = this.$uiRouterGlobals.params.beslutningId;
        if (forespurtBeslutning) {
            if (!this.sak.beslutninger.some(d => d.id === forespurtBeslutning))
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Forespurt beslutning eksisterer ikke'));
            else
                scrollTilSenter(BeslutningListevisningKompaktKomponent.scrollTilElementCssUttrykk(forespurtBeslutning), 100);
        }

        let forespurtAvstemning = this.$uiRouterGlobals.params.avstemningId;
        if (forespurtAvstemning) {
            if (!this.sak.avstemninger.some(d => d.id === forespurtAvstemning))
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Forespurt avstemning eksisterer ikke'));
            else
                scrollTilSenter(`#avst-${forespurtAvstemning}`, 100);
        }
    }

    erGoogleDocsFiltype(filnavn: string) {
        return _.includes(GoogleDriveFilvelgerGui.googleDocsFilendinger, this.filer.filendelse(filnavn));
    }

}


export class PauseKontroller {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmMoetePause', {
              bindings: {
                  pause: '<',
                  sakstidspunkter: '<'
              },
              controller: PauseKontroller.forInjisering(),
              template: require('./pause.html')
          })
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.ui.$stateParams,
            Kontekst.regNavn,
            WebNavigasjon.regNavn,
            ng2RegNavn.SakDatatjenesteForAjs,
            ng2RegNavn.MøteDatatjenesteForAjs,
            ng2RegNavn.Ng2DialogTjenesterForAjs,
            PauseKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $stateParams: IStateParamsService,
                private kontekst: Kontekst,
                private webNavigasjon: WebNavigasjon,
                private sakDatatjenesteForAjs: SakDatatjenesteForAjs,
                private møteDatatjenesteForAjs: MøteDatatjenesteForAjs,
                private ng2DialogTjenesterForAjs: Ng2DialogTjenesterForAjs) {
        //saksrekkefølge oppdatert håndteres via MøteKontroller

        if (this.$stateParams.redigerSak === true) this.redigerPause();

        //last sak når this.sakEndret publiserer (via $onChanges(..))
        kallNedgradertNg2TjenesteVed(
          this.$scope,
          this.pauseEndret,
          this.sakDatatjenesteForAjs.tjeneste(),
          (pause, sakDatatjeneste) => sakDatatjeneste.hent(pause.id, Leveringsvalg.lever_undefined_ved_slettet)
        )
          .subscribe((pause: AgendaelementModell) => {
              if (erIkkeNil(pause)) {
                  this.initPause(kopierFraNg2TilAjs(pause));

              } else {
                  this.møteDatatjenesteForAjs.tjeneste().then(møteDatatjeneste => {
                      //ikke naviger dersom møtet har blitt slettet
                      if (!møteDatatjeneste.eksistererILokallager(this.pause.moete.id)) return;

                      //pause har blitt slettet fra lageret
                      this.webNavigasjon.gåTilMøte(this.pause.moete.id);
                  });
              }
          });
    }

    pause: l.AgendaelementModell; //settes via bindings/$onChanges
    sakstidspunkter: SakstidspunkterBeregning; //settes via bindings/$onChanges

    sakstidspunkt: Sakstidspunkt; //settes via initSakstidspunkt()
    erRedigerPause = false;

    fabMenyAktivert = false;
    redigeringMulig = false;
    kopierMulig = false;

    private pauseEndret = new Subject<l.AgendaelementModell>();

    aktiverFabMeny() {
        this.fabMenyAktivert = true;
    }

    deaktiverFabMeny() {
        this.fabMenyAktivert = false;
    }

    redigerPause() {
        this.erRedigerPause = true;
    }

    redigerPauseFerdig() {
        //denne trigges av ng2-komponent - sørger derfor for at ajs fanger opp endringen
        this.$scope.$applyAsync(() => this.erRedigerPause = false);
    }

    flyttPause() {
        this.ng2DialogTjenesterForAjs.sakFlyttDialog(kopierFraAjsTilNg2(this.pause));
    }

    kopierPause() {
        this.ng2DialogTjenesterForAjs.sakKopierDialog(kopierFraAjsTilNg2(this.pause));
    }

    slettPause() {
        this.sakDatatjenesteForAjs.tjeneste().then(sakDatatjeneste => {
            sakDatatjeneste.slett(this.pause.id);
            //this.pauseEndret subscription vil håndtere nav til møte (ved sletting levers undefined til pause-observatør)
        });
    }

    $onChanges(endringer: IOnChangesObject) {
        dersomChangesInneholder(endringer, 'pause', pause => {
            this.pauseEndret.next(pause); //fører til at ferske data lastes fra server
            this.initPause(pause);
            this.initSakstidspunkt();
        });

        dersomChangesInneholder(endringer, 'sakstidspunkter', sakstidspunkter => this.initSakstidspunkt());
    }

    // hjelpemetoder

    private initPause(pause: l.AgendaelementModell) {
        this.pause = pause;
        this.redigeringMulig = this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.pause.eiendeGruppeId) && !this.pause.moete.laastForRedigering;
        this.kopierMulig = this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.pause.eiendeGruppeId);
    }

    private initSakstidspunkt() {
        if (erNil(this.pause) || erNil(this.sakstidspunkter)) return;

        this.sakstidspunkter.tidspunkterSomObserverbar()
          .pipe(
            //dersom pause har blitt slettet eller flyttet KAN det være at vi får levert tidspunkter som ikke inneholder sak fordi takeUntilAjs$destroy ikke har hatt effekt enda
            filter(tidspunkter => tidspunkter.harForSak(this.pause.id)),
            takeUntilAjs$destroy(this.$scope),
            omsluttLeveringIAjsApplyAsync(this.$scope))
          .subscribe(tidspunkter => this.sakstidspunkt = tidspunkter.forSak(this.pause.id).somAjsTidspunkter());
    }

}
